import React, { useState } from "react";
import Info from "./Info";
import Notify from "./Notify";
import Preferences from "./Preferences";

export default function Basic() {
  const [form, setForm] = useState({
    avatar: "/images/avatar.png",
    name: "Tran Mau Tri Tam",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra id adipiscing id dignissim sed donec. Leo suspendisse non in nulla neque massa metus, sed. Eget amet tincidunt sed montes, quis. Tellus id eget pulvinar ornare egestas netus etestas netus et Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra id adipiscing id dignissim sed donec. Leo suspendisse non in nulla neque massa metus, sed. Eget amet tincidunt  suspendisse non in nulla neque massa metus, sed. Eget",
    facebookLink: "www.facebook.com",
    telegramLink: "www.telegram.com",
    linkedinLink: "www.linkedin.com",
    // notifications
    updates: true,
    newsletter: false,
    purchases: true,
    // preferences
    language: "English",
    theme: "Dark",
    currency: "US Dollar ($)",
  });
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  return (
    <>
      <Info onChangeInput={onChangeInput} form={form} updateForm={updateForm} />
      <Notify
        onChangeInput={onChangeInput}
        form={form}
        updateForm={updateForm}
      />
      <Preferences
        onChangeInput={onChangeInput}
        form={form}
        updateForm={updateForm}
      />
      {/* <Info /> */}
    </>
  );
}
